export default function ImpressumPage() {
  return (
    <div data-testid="impressum-page" className="pt-8">
      {/* Hero Section */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-[#003B70] to-[#002855]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white">
            Impressum
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none text-slate-600">
            
            <h2 className="text-2xl font-semibold text-slate-900 mt-0">
              Angaben gemäß § 5 TMG
            </h2>
            
            <div className="bg-slate-50 p-6 rounded-lg mb-8">
              <p className="mb-0">
                <strong>Jens-Oliver Mansfeld</strong><br />
                Versicherungsvermittler<br />
                Fredericiastraße 6<br />
                14059 Berlin
              </p>
            </div>

            <h3 className="text-xl font-semibold text-slate-900">Kontakt</h3>
            <p>
              Telefon: +49 30 33937950<br />
              E-Mail: info@mansfeld-versicherungen.de
            </p>

            <h3 className="text-xl font-semibold text-slate-900">
              Berufsbezeichnung und berufsrechtliche Regelungen
            </h3>
            <p>
              Berufsbezeichnung: Versicherungsvermittler (Versicherungsvertreter)<br />
              Zuständige Kammer: Industrie- und Handelskammer Berlin<br />
              Verliehen durch: Bundesrepublik Deutschland
            </p>

            <h3 className="text-xl font-semibold text-slate-900">
              Registereintrag
            </h3>
            <p>
              Registrierung gemäß § 34d Abs. 1 GewO als gebundener Versicherungsvertreter<br />
              Registrierungsnummer: D-C3Q2-SJDUH-99<br />
              Registerstelle: Deutscher Industrie- und Handelskammertag (DIHK) e.V.<br />
              Breite Straße 29, 10178 Berlin<br />
              <a href="https://www.vermittlerregister.info" target="_blank" rel="noopener noreferrer" className="text-[#003B70] hover:underline">
                www.vermittlerregister.info
              </a>
            </p>

            <h3 className="text-xl font-semibold text-slate-900">
              Vermittlertätigkeit
            </h3>
            <p>
              Jens-Oliver Mansfeld ist als gebundener Versicherungsvertreter gemäß § 34d Abs. 7 GewO 
              ausschließlich für die zum Konzern der Versicherungskammer Bayern gehörenden Unternehmen tätig.
            </p>

            <h3 className="text-xl font-semibold text-slate-900">
              Vergütung / Transparenzhinweis
            </h3>
            <p>
              Für die Vermittlung von Versicherungsverträgen erhält Jens-Oliver Mansfeld eine 
              Vergütung in Form von Provisionen, die im Versicherungsbeitrag enthalten sind. 
              Die Höhe der Provision richtet sich nach dem jeweiligen Versicherungsprodukt und 
              der Versicherungsgesellschaft. Weitere Vergütungen oder wirtschaftliche Vorteile 
              können im Einzelfall vereinbart werden.
            </p>

            <h3 className="text-xl font-semibold text-slate-900">
              Schlichtungsstellen
            </h3>
            <p>
              Zur außergerichtlichen Beilegung von Streitigkeiten können Sie sich an folgende 
              Schlichtungsstellen wenden:
            </p>
            
            <div className="bg-slate-50 p-6 rounded-lg mb-4">
              <p className="mb-0">
                <strong>Versicherungsombudsmann e.V.</strong><br />
                Postfach 08 06 32<br />
                10006 Berlin<br />
                Telefon: 0800 3696000 (kostenfrei)<br />
                E-Mail: beschwerde@versicherungsombudsmann.de<br />
                <a href="https://www.versicherungsombudsmann.de" target="_blank" rel="noopener noreferrer" className="text-[#003B70] hover:underline">
                  www.versicherungsombudsmann.de
                </a>
              </p>
            </div>

            <div className="bg-slate-50 p-6 rounded-lg mb-4">
              <p className="mb-0">
                <strong>Ombudsmann Private Kranken- und Pflegeversicherung</strong><br />
                Postfach 06 02 22<br />
                10052 Berlin<br />
                Telefon: 0800 2550444 (kostenfrei)<br />
                E-Mail: ombudsmann@pkv-ombudsmann.de<br />
                <a href="https://www.pkv-ombudsmann.de" target="_blank" rel="noopener noreferrer" className="text-[#003B70] hover:underline">
                  www.pkv-ombudsmann.de
                </a>
              </p>
            </div>

            <h3 className="text-xl font-semibold text-slate-900">
              EU-Streitschlichtung
            </h3>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <br />
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#003B70] hover:underline">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder 
              verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle 
              teilzunehmen.
            </p>

            <h3 className="text-xl font-semibold text-slate-900">
              Haftung für Inhalte
            </h3>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
              Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
              allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
              erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend 
              entfernen.
            </p>

            <h3 className="text-xl font-semibold text-slate-900">
              Haftung für Links
            </h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
              Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf 
              mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
              Verlinkung nicht erkennbar.
            </p>
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
              Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
              Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>

            <h3 className="text-xl font-semibold text-slate-900">
              Urheberrecht
            </h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind 
              nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
              Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
              gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, 
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
              werden wir derartige Inhalte umgehend entfernen.
            </p>

          </div>
        </div>
      </section>
    </div>
  );
}
